import { Navigate } from 'react-router-dom';

import type { RotasDoModulo } from '@/app/rotas';

/**
 * Produtos e modalidades.
 *
 * `/produtos` passou a abrir a lista de modalidades da parametrizacao (decisao 4 da
 * secao 11.6 do plano 49). A tela nova faz tudo o que esta fazia (cadastrar e editar
 * produto e modalidade, com a taxa base) e acrescenta o ramo, o grupo e a
 * configuracao da modalidade. O endereco antigo continua valendo, para os favoritos
 * e os links ja enviados.
 */
export const rotas: RotasDoModulo = {
  moldura: [
    {
      path: '/produtos',
      element: <Navigate to="/parametrizacao/modalidades" replace />,
    },
  ],
};
